import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { ProductService } from "src/app/services/product.service";
import { environment } from "src/environments/environment";
import jspdf, { jsPDF } from "jspdf";
import * as htmlToImage from "html-to-image";
import { EventType } from "src/enum/eventtype";
import html2canvas from "html2canvas";
import { DepartmentType } from "src/enum/departmenttype";
import { UserSessionService } from "src/app/services/usersession.service";
import { SharedImageService } from 'src/app/services/shared-image.service';
@Component({
  selector: "app-farmertimeline",
  templateUrl: "./farmertimeline.component.html",
  styleUrls: ["./farmertimeline.component.scss"],
})
export class FarmertimelineComponent implements OnInit {
  @Input() session: any;
  @Input() value: number;
  dealerTimeLineList: any = [];
  environment: any;
  environment3: string;
  environment1: string;
  environment2: string;
  environment4: any;
  environment6: string;
  id: any;
  routeParams: any;
  public eventEnum = EventType;
  public departmentType = DepartmentType;
  workOrderImagePath: any;
  verifcationImage: any;
  physicalVerifyData: any;
  deliveryProductImagePath: any;
  dealerPremisesPlacementImagePath: any;
  dealerPremisesVerificationImagePath: any;
  subsidyPaymentReferenceCopyImagePath: any;
  telematicsKitImagePath: any;
  farmerDocPreviewUrl: string = '';
  farmerDocPreviewTitle: string = '';
  itemdata: any;
  rcPopData: any;
  physicalVerification: any = [];
  physicalVerificationupdate: any = [];
  phisicalverificationList: any;
  verificationList: any = [];
  list: any;
  VerificationList: any[] = [];
  VerificationListupdate: any[] = [];
  environment5: any;
  inspectionImg: any;
  environment7: any;
  environment8: any;
  environment9: any;
  environment10: any;
  environment11: any;
  environment12: any;
  machinaryImage: any;
  chassisImage1: any;
  engineImage1: any;
  machinaryImage1: any;
  imageFilename: string;
  imageBase64: string;
  imageBase64_2:string;
  imageUrl:any;
  item: any;
  lasercutImage1: any;
  constructor(
    private modalService: NgbModal,
    route: ActivatedRoute,
    private productService: ProductService,
    private sharedImageService: SharedImageService
  ) {
  }

  ngOnInit(): void {
    let txt = this.session;
    this.getmanufacturerTimeLine(true);
    this.environment3 = environment.imageBaseUrl + "DBT/DeliveryProductImage/";
    this.environment1 = environment.imageBaseUrl + "DBT/DBTRcBook/";
    this.environment2 = environment.imageBaseUrl + "DBT/DeliveryInvoiceCopy/";
    this.environment4 = environment.imageBaseUrl + "DBT/DBTInspectionPhoto/";
    this.environment5 = environment.imageBaseUrl + "DBT/PreInspectionReport/";
    this.environment6 = environment.imageBaseUrl + 'DBT/ChassisImage/';
    this.environment7 = environment.imageBaseUrl + 'DBT/EngineImage/';
    this.environment8 = environment.imageBaseUrl + 'DBT/DealerPremisesPlacementImage/';
    this.environment9 = environment.imageBaseUrl + 'DBT/DealerPremisesVerificationImage/';
    this.environment10 = environment.imageBaseUrl + 'DBT/SubsidyPaymentReferenceCopy/';
    this.environment11 = environment.imageBaseUrl + 'DBT/FarmerPassBook/';
    this.environment12 = environment.imageBaseUrl + 'DBT/TelematicsKitImage/';
    const image = this.sharedImageService.getImage();
    if (image && image.base64) {
      this.imageBase64 = image.base64;
      this.imageFilename = image.filename;
    } else {
      console.warn("No image data found in shared service.");
    }
  }
  approvedStatusbgColor(eventType: any) {
    var color = "";
    switch (eventType) {
      case 1:
        color = "rgb(16, 183, 89)";
        break;
      case 2:
        color = "rgb(220, 93, 136)";
        break;
      case 3:
        color = "rgb(162, 71, 22)";
        break;
      case 4:
        color = "rgb(114, 124, 245)";
        break;
      case 5:
        color = "rgb(156, 21, 67)";
        break;
      case 6:
        color = "rgb(226, 163, 118)";
        break;
      case 7:
        color = "rgb(193, 150, 31)";
        break;
      case 8:
        color = "rgb(13 153 181)";
        break;
      case 9:
        color = "rgb(255, 51, 102)";
        break;
      case 10:
        color = "rgb(177, 177, 14)";
        break;
      case 11:
        color = "rgb(127, 2, 2)";
        break;
      case 12:
        color = "rgb(60, 201, 201)";
        break;
      case 13:
        color = "rgb(16, 183, 89)";
        break;
      case 14:
        color = "rgb(220, 93, 136)";
        break;
      case 15:
        color = "rgb(154 17 122)";
        break;
      case 16:
        color = "rgb(162, 71, 22)";
        break;
      case 17:
        color = "rgb(114, 124, 245)";
        break;
      case 18:
        color = "rgb(114, 124, 245)";
        break;
      case 19:
        color = "#ed20206b";
        break;
      case 20:
        color = "#04675e";
        break;
      case 21:
        color = "#889f05";
        break;
      case 22:
        color = "#a64360";
        break;
      case 23:
        color = "#4b5f03";
        break;
        case 24:
        color = "#481384";
        break;
        case 25:
          color = "#b659596b";
          break;
        case 29:
          color = "rgb(16, 183, 89)";
          break;
        case 30:
          color = "rgb(162, 71, 22)";
          break;
      default:
        color = "rgb(114, 124, 245)";
        break;
    }
    return color;
  }
  approvedStatusColor(approvedStatusType: any) {
    var color = "";
    switch (approvedStatusType) {
      case 1:
        color = "#fff";
        break;
      case 2:
        color = "#fff";
        break;
        return "#fff";
      case 3:
        color = "#fff";
        break;
        return "#fff";
      case 4:
        color = "#fff";
        break;
        return "#fff";
      case 5:
        color = "#fff";
        break;
        return "#fff";
      case 6:
        color = "#fff";
        break;
        return "#fff";
      case 7:
        color = "#fff";
        break;
        return "#fff";
      case 8:
        color = "#fff";
        break;
        return "#fff";
      case 9:
        color = "#fff";
        break;
        return "#fff";
      case 10:
        color = "#fff";
        break;
        return "#fff";
      case 11:
        color = "#fff";
        break;
        return "#fff";
      case 12:
        color = "#fff";
        break;
        return "#fff";
      case 13:
        color = "#fff";
        break;
        return "#fff";
      case 14:
        color = "#fff";
        break;
        return "#fff";
      case 15:
        color = "#fff";
        break;
      case 16:
        color = "#fff";
        break;
      case 17:
        color = "#fff";
        break;
      case 18:
        color = "#fff";
        break;
      case 19:
        color = "#fff";
        break;
        return "#fff";
        case 20:
        color = "#fff";
        break;
        case 21:
        color = "#fff";
        break;
        case 22:
        color = "#fff";
        break;
        case 23:
        color = "#fff";
        break;
        case 24:
        color = "#fff";
        break;
        case 25:
        color = "#fff";
        break;
      default:
        color = "#fff";
        break;
        return "#fff";
    }
    return color;
  }

  downloadImage(item: any) {

    let src =
    environment.imageBaseUrl +
    "DBT/AdminBookingCancel/" +
    item.adminBookingCancelImagePath;
    const link = document.createElement('a');
    window.open(encodeURI(src), "_blank");
}
  sendBackDowndload(item:any) {
    let src =
    environment.imageBaseUrl +
    "DBT/AdminBookingSenback/" +
    item.adminBookingSenbackImagePath;
    const link = document.createElement('a');
    window.open(encodeURI(src), "_blank");
  }

  openPopup(showImage: any, item: any) {
    this.deliveryProductImagePath = item.deliveryProductImagePath;
    this.itemdata = item;
    this.modalService.open(showImage, { centered: true });
  }
  dealersendBackopenPopup(dealershowImage: any, item: any) {
    this.deliveryProductImagePath = item.deliveryProductImagePath;
    this.itemdata = item;
    this.modalService.open(dealershowImage, { centered: true });
  }
  openPlacementPopup(showPlacementImage: any, item: any) {
    this.dealerPremisesPlacementImagePath = item.dealerPremisesPlacementImagePath;
    this.itemdata = item;
    this.modalService.open(showPlacementImage, { centered: true });
  }
  openVerificationPopup(showVerificationImage: any, item: any) {
    this.dealerPremisesVerificationImagePath = item.dealerPremisesVerificationImagePath;
    this.itemdata = item;
    this.modalService.open(showVerificationImage, { centered: true });
  }
  // Subsidy payment info by dealer (target-flow step 8) — see CLAUDE.md.
  openSubsidyPaymentPopup(showSubsidyPaymentImage: any, item: any) {
    this.subsidyPaymentReferenceCopyImagePath = item.subsidyPaymentReferenceCopyImagePath;
    this.itemdata = item;
    this.modalService.open(showSubsidyPaymentImage, { centered: true });
  }
  
  isPdfPath(path: string): boolean {
    return !!path && path.toLowerCase().endsWith('.pdf');
  }
  openAttachment(baseUrl: string, path: string) {
    window.open(encodeURI(baseUrl + path), "_blank");
  }
  
  openFarmerDocPreview(template: any, url: string, title: string) {
    this.farmerDocPreviewUrl = url;
    this.farmerDocPreviewTitle = title;
    this.modalService.open(template, { centered: true });
  }
  openTelematicsKitPopup(showTelematicsKitImage: any, item: any) {
    this.telematicsKitImagePath = item.telematicsKitImagePath;
    this.itemdata = item;
    this.modalService.open(showTelematicsKitImage, { centered: true });
  }
  openPopup1(showImage1: any, item: any) {
    this.modalService.open(showImage1, { centered: true });
    this.rcPopData = item;
  }
  dealersendopenPopup1(dealershowImage1: any, item: any) {
    this.modalService.open(dealershowImage1, { centered: true });
    this.rcPopData = item;
  }
  openPopup2(showImage2: any) {
    this.modalService.open(showImage2, { centered: true });
  }
  openPopup3(showImage3: any, item: any) {
    this.verifcationImage = item.image;
    this.physicalVerifyData = item;
    this.modalService.open(showImage3, { centered: true });
  }
  preInspectionReport(showImg: any, item: any) {
    this.inspectionImg = item;
    this.modalService.open(showImg, { centered: true });
  }
  openmachinaryImage(machinaryImage:any,item:any){
    this.machinaryImage1 = item;
    this.modalService.open(machinaryImage, { centered: true });
  }
  openchassisImage(chassisImage:any,item:any){
    this.chassisImage1 = item;
    this.modalService.open(chassisImage, { centered: true });
  }
  openengineImage(engineImage:any,item:any){
    this.engineImage1 = item;
    this.modalService.open(engineImage, { centered: true });
  }
  
  getmanufacturerTimeLine(refresh: boolean) {
    this.productService
      .getTimeline(this.session.id, true)
      .subscribe((result) => {
        if (result) {
          this.dealerTimeLineList = result;
          for (let i = 0; i < this.dealerTimeLineList.length; i++) {
            let e = this.dealerTimeLineList[i];
            if (e.verificationList && e.eventType == 9) {
              this.physicalVerification = e.verificationList;
            }
            if (e.verificationList && e.eventType == 25) {
              this.physicalVerificationupdate = e.verificationList;
            }
          }

          this.VerificationList = [
            {
              name: "Aadhaar Verification",
              isSelect: false,
            },
            {
              name: "Community certificate (SC/ST)",
              isSelect: false,
            },
            {
              name: "Farmer certificate (SF/MF)",
              isSelect: false,
            },
            {
              name: "Patta / Chitta",
              isSelect: false,
            },
            {
              name: "Adangal",
              isSelect: false,
            },
            {
              name: "Engine no / Chassis no / Serial no verificatio",
              isSelect: false,
            },
          ];
          this.VerificationListupdate = [
            {
              name: "Aadhaar Verification",
              isSelect: false,
            },
            {
              name: "Community certificate (SC/ST)",
              isSelect: false,
            },
            {
              name: "Farmer certificate (SF/MF)",
              isSelect: false,
            },
            {
              name: "Patta / Chitta",
              isSelect: false,
            },
            {
              name: "Adangal",
              isSelect: false,
            },
            {
              name: "Engine no / Chassis no / Serial no verificatio",
              isSelect: false,
            },
          ];

          this.VerificationList.forEach((e) => {
            var data = this.physicalVerification.filter(
              (a) => a.value == e.name
            );
            if (data.length > 0) {
              e.isSelect = true;
            }
          });
          this.VerificationListupdate.forEach((e) => {
            var data = this.physicalVerificationupdate.filter(
              (a) => a.value == e.name
            );
            if (data.length > 0) {
              e.isSelect = true;
            }
          });
        }
      });
  }
  downloadTimeline() {
    const filename = "Timeline.pdf";
    const node = document.getElementById("timelineContent");
    htmlToImage
      .toPng(node)
      .then((dataUrl) => {
        const img = new Image();
        img.src = dataUrl;
        const pdf = new jspdf("p", "mm", "a4");
        pdf.setLineWidth(1);
        pdf.addImage(img, "png", 3, 20, 220, 150);
        pdf.save(filename);
      })
      .catch((error) => {
        console.error("oops, something went wrong!", error);
      });
  }
  download1() {
    html2canvas(document.querySelector("#element")).then((canvas) => {
      const pdf = new jsPDF();
      pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, 211, 298);
      pdf.save("Timeline.pdf");
    });
  }
  downdload(item: any) {

    let src =
      environment.imageBaseUrl + "WorkOrderReceipt/" + item.workOrderImagePath;

    window.open(encodeURI(src), "_blank");
  }

  referenceDowndload(item: any) {
    let src =
      environment.imageBaseUrl +
      "DBT/PaymentReferenceCopy/" +
      item.paymentCopyImagePath;

    window.open(encodeURI(src), "_blank");
  }
  eebookingcancelDowndload(item: any) {
    let src =
      environment.imageBaseUrl +
      "DBT/EEdbtBookingCancelCopy/" +
      item.eEdbtBookingCancelImagePath;

    window.open(encodeURI(src), "_blank");
  }
  Invoicedowndload(item) {
    let src =
      environment.imageBaseUrl +
      "DBT/DeliveryInvoiceCopy/" +
      item.deliveryInvoiceCopyImagePath;

    window.open(encodeURI(src), "_blank");
  }
  rcdowndload(item) {
    let src =
      environment.imageBaseUrl +
      "DBT/DBTRcBook/" +
      item.rcBookImagePath;

    window.open(encodeURI(src), "_blank");
  }
  laserCutdowndload(item) {
    let src =
      environment.imageBaseUrl +
      "DBT/LaserCut/" +
      item.laserCutImagePath;

    window.open(encodeURI(src), "_blank");
  }
  passbookdowndload(item) {
    let src =
      environment.imageBaseUrl +
      "DBT/FarmerPassBook/" +
      item.farmerBankPassBookImagePath;

    window.open(encodeURI(src), "_blank");
  }
  additionalSubsidyPassbookdowndload(item) {
    let src =
      environment.imageBaseUrl +
      "DBT/FarmerPassBook/" +
      item.additionalSubsidyBankPassBookImagePath;

    window.open(encodeURI(src), "_blank");
  }
    AElaserCutdowndload(item) {
    let src =
      environment.imageBaseUrl +
      "DBT/AELaserCut/" +
      item.physicalVerificationLaserCutImagePath;
    window.open(encodeURI(src), "_blank");
  }
  dealersendInvoicedowndload(item) {
    let src =
      environment.imageBaseUrl +
      "DBT/DeliveryInvoiceCopy/" +
      item.deliveryInvoiceCopyImagePath;

    window.open(encodeURI(src), "_blank");
  }
  InspectionDowndload(item: any) {
    let src =
      environment.imageBaseUrl +
      "DBT/PreInspectionReport/" +
      item.preInspectionReportImagePath;

    window.open(encodeURI(src), "_blank");
  }
  physicalVerificationDownload(item: any){
    let src =
    environment.imageBaseUrl +
    "DBT/PhysicalVerificationReport/" +
    item.physicalVerificationReportImagePath;

  window.open(encodeURI(src), "_blank");
  }

}
